/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Atm = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.5 2.5L20.5 2.5L20.5 9L19 9L19 10.5L20.5 10.5L22 10.5L22 9L22 2.5L22 1L20.5 1L3.5 0.999999L2 0.999999L2 2.5L2 9L2 10.5L3.5 10.5L5 10.5L5 9L3.5 9L3.5 2.5ZM19 4L5 4L5 7.5L6 7.5L6 23L18 23L18 7.5L19 7.5L19 4ZM16.5 5.5L7.5 5.5L7.5 7.5L7.5 21.5L16.5 21.5L16.5 7.5L16.5 5.5ZM16.235 12.564L15.416 12.564C15.227 13.671 14.507 14.391 13.463 14.445L13.463 13.077C13.859 13.005 14.237 12.618 14.237 11.988C14.237 11.448 14.021 11.124 13.652 11.124C13.319 11.124 13.157 11.376 13.049 11.754L12.779 12.735C12.509 13.671 12.086 14.481 10.781 14.481C9.746 14.481 9.017 13.743 8.864 12.564L8 12.564L8 11.421L8.891 11.421C9.107 10.269 9.944 9.504 11.15 9.45L11.15 10.818C10.529 10.872 10.043 11.394 10.043 12.06C10.043 12.654 10.322 13.059 10.745 13.059C11.114 13.059 11.33 12.762 11.447 12.366L11.717 11.394C11.969 10.467 12.437 9.693 13.643 9.693C14.543 9.693 15.227 10.395 15.416 11.421L16.235 11.421L16.235 12.564ZM12.75 20L11.25 20L11.25 17L12.75 17L12.75 20Z"
                        fill={color}
                    />
                </svg>
        );
    };
